<template>
  <div>
    <label :for="label" class="block text-sm font-medium text-gray-700">{{ label }}</label>
    <div
      class="mt-1 flex rounded-md shadow-sm border border-gray-300 bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 relative"
    >
      <span class="flex items-center pl-3 text-gray-500 sm:text-sm">$</span>
      <input
        :id="label"
        type="text"
        :name="label"
        class="bg-white border-0 focus:ring-0 focus:border-0 px-3 py-2 min-h-[38px] text-gray-700 sm:text-sm flex-1 rounded-none"
        :placeholder="placeholder"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <select
        id="Currency"
        name="currency"
        class="bg-white border-0 rounded-r-md focus:ring-0 focus:border-0 px-2 py-2 min-h-[38px] text-gray-700 sm:text-sm"
      >
        <option>USD</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'label', 'placeholder'],
};
</script>
